import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  constructor( private router: Router) {

  }
  ngOnInit() {
    if(window.location['pathname']!=="/admin" && window.location['pathname']!=="/dashboard")
    this.router.navigate(['']);
  }
}
